import React from "react";
import './MakeAccountPublic.css';
import RectangularLogo from './rectangular-logo.png';

function MakeAccountPublic() {
  return (
    <div className="account-public-container">
      <main className="content">
        <img src={RectangularLogo} alt="Logo" className="main-logo" />
        <h1 className="title">Make Your Instagram Account Public</h1>

        <section className="instructions-section">
          <h2>Step-by-Step Instructions</h2>
          <ol>
            <li>
              <strong>Log In to Instagram:</strong> Open your Instagram app or visit the website and sign in to your account.
            </li>
            <li>
              <strong>Switch to a Professional Account:</strong> Navigate to your profile settings, tap on "Account" and select "Switch to Professional Account." Choose the <em>Creator</em> option.
            </li>
            <li>
              <strong>Set Your Account to Public:</strong> Go to <em>Settings &gt; Privacy &gt; Account Privacy</em> and make sure the "Private Account" toggle is turned off. This step is crucial so that the Instagram API can pull data from your account.
            </li>
            <li>
              <strong>Verify Your Public Profile:</strong> Check your profile by logging out or viewing it in a browser. Your posts should be visible to everyone.
            </li>
            <li>
              <strong>Connect to Our Platform:</strong> Once your account is public, return here and connect your Instagram account. If you encounter an error stating that your account is not a public creator account, double-check that you have completed the previous steps.
            </li>
          </ol>
        </section>

        <section className="error-info">
          <h2>Common Error: Account Not Set as Public Creator</h2>
          <p>
            If you receive an error during generation, it could be due to one or more of the following:
          </p>
          <ul>
            <li>Your account is still set to private.</li>
            <li>You have not switched to a Creator (or Business) account.</li>
            <li>Instagram API restrictions require a public profile for data access.</li>
          </ul>
          <p>
            Please review and update your account settings accordingly. Once your account is public, try generating again.
          </p>
        </section>

      </main>
      <footer className="footer">
        &copy; 2025 Bytenest LLC. All rights reserved.
      </footer>
    </div>
  );
}

export default MakeAccountPublic;
